import { render, staticRenderFns } from "./HubTable.vue?vue&type=template&id=3b27381e&scoped=true"
import script from "./HubTable.vue?vue&type=script&lang=js"
export * from "./HubTable.vue?vue&type=script&lang=js"
import style0 from "./HubTable.vue?vue&type=style&index=0&id=3b27381e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b27381e",
  null
  
)

export default component.exports